import { getFunctions, httpsCallable /*, connectFunctionsEmulator */ } from "firebase/functions";
import { functions } from "./firebase";


/** LINEユーザー作成・更新（onCall） */
export const createLineUser = httpsCallable(functions, 'createLineUser');
/** LINEプロフィール取得（onCall） */
export const getLineProfile = httpsCallable(functions, 'getLineProfile');


export const startInhouseReception = (data = {}) =>
  httpsCallable(functions, "startInhouseReception")(data);

export const endInhouseReception = (data = {}) =>
  httpsCallable(functions, "endInhouseReception")(data);

export const startOnlineReception = (data = {}) =>
  httpsCallable(functions, "startOnlineReception")(data);

export const endOnlineReception = (data = {}) =>
  httpsCallable(functions, "endOnlineReception")(data);

export const allocateNextSlot = (data = {}) =>
  httpsCallable(functions, "allocateNextSlot")(data).then(r => r.data);

export const sendReservationMessageBySlot = (data = {}) =>
  httpsCallable(functions, "sendReservationMessageBySlot")(data);

export const cancelReservation = (data = {}) =>
  httpsCallable(functions, "cancelReservation")(data);

